import { getToken } from "helper/common";
import {
    CLEAR_APP_VERSION_LIST,
    SET_APP_VERSION_LIST,
    APP_VERSION_CREATE_DIALOG_CLOSE,
    APP_VERSION_CREATE_DIALOG_OPEN,
    APP_VERSION_CREATE_ERROR,
    APP_VERSION_CREATE_ERROR_CLEAR,
    APP_VERSION_CREATE_PENDING,
    APP_VERSION_EDIT_DIALOG_CLOSE,
    APP_VERSION_EDIT_DIALOG_OPEN,
    APP_VERSION_EDIT_ERROR,
    APP_VERSION_EDIT_ERROR_CLEAR,
    APP_VERSION_EDIT_PENDING,
    APP_VERSION_LIST_ERROR,
    APP_VERSION_LIST_ERROR_CLEAR,
    APP_VERSION_LIST_PENDING,
    APP_VERSION_DETAIL_PENDING,
    CLEAR_APP_VERSION_DETAILS,
    SET_APP_VERSION_DETAILS,
    SET_APP_VERSION_FILTER_DATA,
    APP_VERSION_FILTER_DIALOG_OPEN,
    APP_VERSION_FILTER_DIALOG_CLOSE,
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { trimmedValues } from "helper/trim";
import { encodeObjectValues } from "helper/encodeData";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setAppVersionList = (appVersionList) => ({
    type: SET_APP_VERSION_LIST,
    payload: { appVersionList }
});

export const clearAppVersionList = () => ({
    type: CLEAR_APP_VERSION_LIST,
});

export const appVersionListPending = () => ({
    type: APP_VERSION_LIST_PENDING
});

export const appVersionListError = (errorMessage) => ({
    type: APP_VERSION_LIST_ERROR,
    payload: { errorMessage }
});

export const appVersionListErrorClear = () => ({
    type: APP_VERSION_LIST_ERROR_CLEAR
});


export const getAppVersionList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter })
    dispatch(appVersionListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.appVersion.getAppVersionList(accessToken, page, pageSize, sortOrder, sortDirection, encodeFilters)
            .then((appVersionList) => {
                dispatch(setAppVersionList(appVersionList));
                dispatch(appVersionListErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(appVersionListError(message));
                }
                else {
                    dispatch(appVersionListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openAppVersionFilterDialog = () => ({
    type: APP_VERSION_FILTER_DIALOG_OPEN
});

export const closeAppVersionFilterDialog = () => ({
    type: APP_VERSION_FILTER_DIALOG_CLOSE
});

export const setAppVersionFilteredData = (filter) => ({
    type: SET_APP_VERSION_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| DETAILS ||------------------------------------------------------------

export const appVersionDetailPending = (id) => ({
    type: APP_VERSION_DETAIL_PENDING,
    payload: { id }
})

export const setAppVersionDetails = (appVersionDetails) => ({
    type: SET_APP_VERSION_DETAILS,
    payload: { appVersionDetails }
});

export const clearAppVersionDetails = () => ({
    type: CLEAR_APP_VERSION_DETAILS,
})

export const getAppVersionDetails = (id) => (dispatch) => {
    dispatch(appVersionDetailPending(id));
    return getToken(dispatch).then((accessToken) => {
        return agent.appVersion.getAppVersionDetails(accessToken, id)
            .then((appVersions) => {
                dispatch(setAppVersionDetails(appVersions));
                dispatch(openAppVersionEditDialog());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(appVersionListError(message));
                }
                else {
                    dispatch(appVersionListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}
//-----------------------------|| CREATE ||---------------------------------------------------------------
export const openAppVersionCreateDialog = () => ({
    type: APP_VERSION_CREATE_DIALOG_OPEN
});

export const closeAppVersionCreateDialog = () => ({
    type: APP_VERSION_CREATE_DIALOG_CLOSE
});

export const appVersionCreatePending = () => ({
    type: APP_VERSION_CREATE_PENDING
});

export const appVersionCreateError = (errorMessage) => ({
    type: APP_VERSION_CREATE_ERROR,
    payload: { errorMessage }
});

export const appVersionCreateErrorClear = () => ({
    type: APP_VERSION_CREATE_ERROR_CLEAR
});

export const appVersionCreate = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(appVersionCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.appVersion.appVersionCreate(accessToken, dataToSend)
            .then(() => {
                dispatch(getAppVersionList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(appVersionCreateErrorClear());
                dispatch(closeAppVersionCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'App version successfully created.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(appVersionCreateError(message));
                }
                else {
                    dispatch(appVersionCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openAppVersionEditDialog = () => ({
    type: APP_VERSION_EDIT_DIALOG_OPEN
});

export const closeAppVersionEditDialog = () => ({
    type: APP_VERSION_EDIT_DIALOG_CLOSE
});

export const appVersionEditPending = () => ({
    type: APP_VERSION_EDIT_PENDING
});

export const appVersionEditError = (errorMessage) => ({
    type: APP_VERSION_EDIT_ERROR,
    payload: { errorMessage }
});

export const appVersionEditErrorClear = () => ({
    type: APP_VERSION_EDIT_ERROR_CLEAR
});

export const appVersionEdit = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(appVersionEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.appVersion.appVersionEdit(accessToken, dataToSend)
            .then(() => {
                dispatch(getAppVersionList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(closeAppVersionEditDialog());
                dispatch(appVersionEditErrorClear());
                dispatch(openSnackbar({
                    open: true,
                    message: 'App version details successfully updated.',
                    variant: 'alert',
                    close: false
                }))
                return Promise.resolve(true);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(appVersionEditError(message));
                }
                else {
                    dispatch(appVersionEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}
